import { render, staticRenderFns } from "./ButtonLottieIcon.vue?vue&type=template&id=54cc888a"
import script from "./ButtonLottieIcon.vue?vue&type=script&lang=js"
export * from "./ButtonLottieIcon.vue?vue&type=script&lang=js"
import style0 from "./ButtonLottieIcon.vue?vue&type=style&index=0&id=54cc888a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports